import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteStopsFailed, deleteStopsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* deleteStops(action) {
  try {
    const url = `${BACKEND_MDS_URL}/agency/vehicles/stops/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteStopsSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteStopsFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteStopsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
